import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
function Exposure() {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [capacity, setCapacity] = useState(null);

  useEffect(() => {
    setReady(false);
    setError(null);

    function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
      whereClause += ' AND license_type=LIC AND (setting_type=HOM OR setting_type=CEN) AND is_near_high_risk_site=1';

      return rdsTabulate('ccdc', 'provider', {
        dims: 'state',
        measure: 'capacity:COUNT(*)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    Promise.all([getCapacity()])
      .then((responses) => {
        setCapacity(responses[0].parsedBody.dataProvider[0].capacity);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <Typography variant="body1">
        In <b>{states[stateCode.toUpperCase()]}</b>, <b>{toFormattedNumber(capacity)}</b> child care programs are located in high-risk locations. Risk varies by setting type and subsidy acceptance.
      </Typography>
    </>
  );
}

export default Exposure;
